<template>
  <div class="troubleshooting">
    <div class="troubleshooting-content">
      <div class="top-container">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="demo-ruleForm"
        >
          <div class="row">
            <el-form-item label="时间：" prop="date">
              <el-date-picker
                v-model="ruleForm.date"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="回复状态：" prop="status">
              <el-select
                v-model="ruleForm.status"
                placeholder="请选择"
                class="gray white"
                clearable
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="btn">
              <el-button class="btn-gray" @click="resetForm('ruleForm')"
                >重置</el-button
              >
              <el-button class="btn-blue" type="primary" @click="search"
                >搜索</el-button
              >
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="troubleshooting-container">
        <div class="table" v-if="totalNum > 0">
          <el-table
            :data="tableData"
            style="width: 100%"
          >
            <el-table-column label="询问内容" min-width="300">
              <template slot-scope="scope">
                <el-tooltip v-if="!isShowTooltip" class="item" effect="dark" placement="top-start">
                  <div slot="content">
                    <span v-for="(item, index) in scope.row.content" :key="index">
                      <span style="display:inline-block;">
                        {{item}}
                      </span>
                      <br v-if="(index+1)%20==0"/>
                    </span>
                  </div>
                  <div :class="scope.row.isChoice == 1 ? 'high-risk': ''">
                    <span :ref="`refTooltip${scope.$index}`" @mouseover="onMouseOver(`refTooltip${scope.$index}`)"
                    >{{scope.row.content}}</span>
                  </div>
                </el-tooltip>
                <div v-else :class="scope.row.isChoice == 1 ? 'high-risk': ''">
                  <span :ref="`refTooltip${scope.$index}`" @mouseover="onMouseOver(`refTooltip${scope.$index}`)"
                  >{{scope.row.content}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-for="(item, index) in tableTitleList"
              :key="index"
              :prop="item.prop"
              :label="item.lable"
              :min-width="item.width"
              :show-overflow-tooltip="item.showOverflowTooltip"
            />
            <el-table-column label="规制" min-width="150">
              <template slot-scope="scope">
                <el-tooltip v-if="!isShowTooltip" class="item" effect="dark" placement="top-start">
                  <div slot="content">
                    <span v-for="(item, index) in scope.row.rule" :key="index">
                      <span style="display:inline-block;">
                        {{item}}
                      </span>
                      <br v-if="(index+1)%20==0"/>
                    </span>
                  </div>
                  <div>
                    <span :ref="`refRule${scope.$index}`" @mouseover="onMouseOver(`refRule${scope.$index}`)"
                    >{{scope.row.rule}}</span>
                  </div>
                </el-tooltip>
                <div v-else>
                  <span :ref="`refRule${scope.$index}`" @mouseover="onMouseOver(`refRule${scope.$index}`)"
                  >{{scope.row.rule}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  v-if="!scope.row.isChoice"
                  type="text"
                  class="btn-text"
                  @click="setSelected(scope.row.id)"
                  >设为精选</el-button
                >
                <el-button
                  v-else
                  type="text"
                  class="btn-text"
                  @click="concalSelected(scope.row.id)"
                  >取消精选</el-button
                >
                <el-button
                  v-if="!scope.row.IsReply"
                  type="text"
                  class="btn-text"
                  @click="reply(scope.row.id)"
                  >回复</el-button
                >
                <el-tooltip  v-else class="item" effect="dark" placement="top-end">
                  <div slot="content">
                    <span v-for="(item, index) in scope.row.replyText" :key="index">
                      <span style="display:inline-block;">
                        {{item}}
                      </span>
                      <br v-if="(index+1)%20==0"/>
                    </span>
                  </div>
                  <el-button
                    type="text"
                    class="btn-lightGrey"
                    >查看回复</el-button
                  >
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-tpl-container">
            <pagination-tpl
              :total="totalNum"
              :currentPage="currentPage"
              @queryChange="onQueryChange"
            ></pagination-tpl>
          </div>
        </div>
        <div class="nothing" v-if="totalNum == 0">
          <div>
            <div>
              <img src="../../../../assets/nothing.png" />
            </div>
            <p>暂无数据</p>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="540px"
      :before-close="handleClose"
    >
      <el-form :model="form" ref="form">
        <el-form-item
          label="回复内容"
          prop="content"
        >
          <el-input
            class="gray white"
            v-model="form.content" 
            type="textarea"
            placeholder="请输入详细内容"
            :autosize="{ minRows: 5, maxRows: 5 }"
            resize="none"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confirm('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { config } from "@/common/js/config.js";
import PaginationTpl from "@/components/PaginationTpl.vue";
import Troubleshooting from "@/models/troubleshooting.js";
import {
  formaTimeToMinute
} from "@/common/js/utils.js";
export default {

  components: {
    PaginationTpl,
  },

  data() {
    return {
      id: '',
      ruleForm: {
        date: '',
        status: ''
      },
      statusList: [
        {id:0, name: '未回复'},
        {id:1, name: '已回复'}
      ],
      totalNum: 0,
      currentPage: 1,
      tableData: [],
      tableTitleList: [
        {
          prop: "creatTime",
          lable: "时间",
          width: "150",
          showOverflowTooltip: true,
        },
        {
          prop: "name",
          lable: "用户",
          width: "100",
          showOverflowTooltip: true,
        },
      ],
      dialogTitle: "回复",
      dialogVisible: false,
      form: {
        content: '',
      },
      isShowTooltip: true
    }
  },

  created() {
    config()
    this.initList()
  },

  methods: {
    onMouseOver(str) {
      const tag = this.$refs[str]
      // 获取父级元素的可视高度
      const parentHeight = tag.parentNode.offsetHeight
      // 获取元素的可视高度
      const contentHieght = tag.offsetHeight
      this.isShowTooltip = contentHieght <= parentHeight
    },
    initList() {
      let currentPage = this.currentPage;
      let hasReply = this.ruleForm.status
      let startTime = this.ruleForm.date? this.ruleForm.date[0] : ''
      let endTime = this.ruleForm.date? this.ruleForm.date[1] : ''
      let data = {
        currentPage,
        hasReply,
        startTime,
        endTime
      }
      Troubleshooting.getTroubleshootingList(data).then(res => {
        if (res.success) {
          this.totalNum = res.result.totalNum;
          let arr = []
          res.result.items.map((i) => {
            let obj = {}
            obj.id = i.id
            obj.content = i.comment
            obj.creatTime = formaTimeToMinute(i.createTime)
            obj.name = i.userName
            obj.rule = i.titleName
            obj.isChoice = i.isSelected
            obj.IsReply = i.hasReply
            obj.replyText = i.adminReply
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },
    /* 搜索 */
    search() {
      this.currentPage = 1;
      this.initList();
    },

    /* 重置 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /* 翻页 */
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.initList();
    },
    reply(id) {
      this.id = id
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    clear() {
      this.form.content = ''
    },
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.replyContent()
          this.clear();
          this.handleClose();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    replyContent() {
      let id = this.id
      let comment = this.form.content
      let data = {
        id,
        comment
      }
      Troubleshooting.postReply(data).then(res => {
        if (res.success) {
          this.initList();
        } else {
          this.$message.error(res.message)
        }
      })
    },
    setSelected(id) {
      this.setSelectedOrConcalSelected(id)
    },
    concalSelected(id) {
      this.setSelectedOrConcalSelected(id)
    },
    setSelectedOrConcalSelected(id) {
      let data = {
        id
      }
      Troubleshooting.postSetSelectedOrConcalSelected(data).then(res => {
        if (res.success) {
          this.initList();
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>

<style lang='scss'>
.troubleshooting {
  flex: 1;
  width: 100%;
  background: $bg-WhiteSmoke;
  .troubleshooting-content {
    height: 100%;
    @include flex-column-start;
  }
  .top-container {
    width: 100%;
    box-sizing: border-box;
    background: $bg-white;
    padding: 20px 10px 10px 10px;
    .el-form-item__label {
      width: 100px;
      height: 32px;
      line-height: 32px;
      padding: 0;
    }
    .el-form-item {
      width: 340px;
      margin-bottom: 10px;
      display: flex;
      .el-form-item__content {
        line-height: 32px;
      }
    }
    .el-select {
      .el-input__suffix {
        top: -3px;
      }
    }
    .row {
      @include flex-start;
      .btn {
        .el-form-item__content {
          display: flex;
        }
      }
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
      width: 100%;
      height: 100%;
    }
  }
  .troubleshooting-container {
    flex: 1;
    width: 100%;
    margin-top: 20px;
    padding: 8px 10px;
    background: $bg-white;
    box-sizing: border-box;
    position: relative;
    .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
      height: auto;
      line-height: 22px;
      @include two-wrap-ellipsis();
    }
    
    .high-risk {
      @include border-left(3px, 30px, $high-risk, -16px, 50%)
    }

    .nothing {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      img {
        width: 157px;
        height: 157px;
      }
      p {
        font-size: $fs-small-l;
        font-weight: 400;
        color: $color-LightGrey;
        margin-top: 24px;
      }
    }
    
  }
}
</style>
